import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data from '../../data/data23.json';
import ArticleList from '../../Components/ArticleList';

const Regulations: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>规章制度</h1>
                <ArticleList dataId="23" data={data as any} />
            </div>
        } />
    );
};

export default Regulations;